import { useAuthContext } from '~/shared/context/useAuthContext';
import PageContainer from '~/shared/components/PageContainer';

// import { RoleArnOrganization } from './components/RoleArnOrganization';
import { RoleArn } from './components/RoleArn';

export default function PermissionsPage() {
  const { activeTenantName } = useAuthContext();

  return (
    <PageContainer className="px-[30px] bg-gree">
      {/* <div className="text-primary-900 opacity-50 text-[14px] font-semibold leading-[24px] mb-[24px]">
        Permissions
      </div> */}

      <RoleArn activeTenantName={activeTenantName || ''} />
      {/* <RoleArnOrganization activeTenantName={activeTenantName || ''} /> */}
    </PageContainer>
  );
}
